import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from '../../whitelabel/theme.service';

@Component({
  selector: 'pay-login-activation-layout',
  imports: [RouterOutlet, TranslateModule, NgOptimizedImage],
  templateUrl: './activation-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivationLayoutComponent {
  headerName = ThemeService.text;
}
